import React from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';

import CircleBanner from '../../elements/circle-banner';
import ContactInfo from './contact-info';
import ContactRows from './contact-rows';
import ContactWave from './contact-wave';

const ContactContainer = styled.div``;

const Contact = () => {
    const data = useStaticQuery(graphql`
        query {
            allWpPage(filter: { title: { eq: "Contact Us" } }) {
                edges {
                    node {
                        id
                        title
                        slug
                        contact_addons {
                            contactBanner {
                                bannerHeadline
                                bannerCaption
                                bannerBgColor
                            }

                            contactContentColumns {
                                contentColumnContent
                                contentColumnButton {
                                    title
                                    url
                                }
                                contentColumnTitle
                                contentColumnColor
                            }
                            contactInfo {
                                contactHeadline
                                contactCaption
                                contactButton {
                                    title
                                    url
                                }
                            }
                            contactBottomBanner {
                                bottomBannerAddress
                                bottomBannerCaption
                                bottomBannerHeadline
                                bottomBannerImage {
                                    localFile {
                                        childImageSharp {
                                            fluid(maxWidth: 1440) {
                                                ...GatsbyImageSharpFluid
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    const {
        contactBanner,
        contactInfo,
        contactContentColumns,
        contactBottomBanner,
    } = (data && data.allWpPage.edges[0].node.contact_addons) || {};

    return (
        <ContactContainer>
            <CircleBanner content={contactBanner} />
            <ContactInfo info={contactInfo} />
            <ContactRows columns={contactContentColumns} />
            <ContactWave content={contactBottomBanner} />
        </ContactContainer>
    );
};

export default Contact;
